export const LIGHT = "LIGHT";
export const DARK = "DARK";
export const theme = {
  light: "#fff",
  dark: "rgb(20, 19, 34)",
};
